import React, { memo } from 'react';

import classNames from 'classnames';

import File from '../File';

import classes from './styles.module.scss';
import uploadIcon from '../../../assets/images/create-meeting/upload.svg';
import imagePlaceholder from '../../../assets/images/create-meeting/imagePlaceholder.svg';

function Files({
  withText,
  prevFiles,
  setPrevFiles,
  setDeletedPrevFilesIds,
  setSelectedFileId,
  setDescriptions,
  selectedFileId,
  files,
  setFiles,
  inputRef,
  noFiles,
}) {
  const openFileDialog = () => {
    inputRef.current.click();
  };

  const fileCount = (files.length ?? 0) + (prevFiles.length ?? 0);

  return (
    <div
      className={classNames(classes.Files, {
        [classes.withText]: withText,
      })}
    >
      {prevFiles && prevFiles.length > 0
        ? prevFiles.map((file) => {
            return (
              <File
                key={file.name}
                file={file}
                onDelete={() => {
                  setPrevFiles((prev) =>
                    prev.filter((prevFile) => prevFile.id !== file.id)
                  );
                  setDeletedPrevFilesIds((prev) => {
                    return [...prev, file.id];
                  });
                  setSelectedFileId('');
                  setDescriptions((prev) => {
                    return prev.filter((desc) => desc.id !== file.id);
                  });
                }}
                isSelected={selectedFileId === file.id}
                onClick={() => {
                  setSelectedFileId(file.id);
                }}
              />
            );
          })
        : null}
      {files.length
        ? files.map((file) => {
            return (
              <File
                key={file.name}
                file={file}
                onDelete={() => {
                  setFiles((prev) =>
                    prev.filter((prevFile) => prevFile.name !== file.name)
                  );
                  setSelectedFileId('');
                  setDescriptions((prev) => {
                    return prev.filter((desc) => desc.size !== file.size);
                  });
                }}
                isSelected={selectedFileId === file.size}
                onClick={() => {
                  setSelectedFileId(file.size);
                }}
              />
            );
          })
        : null}
      {fileCount < 10 && (
        <button
          onClick={openFileDialog}
          className={classes.placeholder}
          type="button"
        >
          <img src={imagePlaceholder} alt="Placeholder" />
          <span>Add image</span>
        </button>
      )}
      {noFiles && false && (
        <div className={classes.uploader} onClick={openFileDialog}>
          <img src={uploadIcon} alt="Upload" />
          <p>Import files to attach within your video</p>
        </div>
      )}
    </div>
  );
}

export default memo(Files);
